import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  APIFetcher,
  FiltersAndPagination,
  SalesOrderRow,
} from '../utils/axios';
import { OneSalesOrderRow } from './orders/oneSalesOrderRow';

interface OutGoingTableProps {
  filters: FiltersAndPagination;
  setPages: React.Dispatch<React.SetStateAction<any>>;
}

export const OutGoingTable: React.FC<OutGoingTableProps> = ({
  filters,
  setPages,
}) => {
  const [orders, setOrders] = useState<SalesOrderRow[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    async function getOrders() {
      const res = await APIFetcher.getAllOutGoing(filters);
      setPages(Math.ceil(res.data.totalCount / filters.limit));
      setOrders(res.data.data);
    }
    getOrders();
  }, [filters.page]);
  return (
    <table className="table table-borderless">
      <thead>
        <tr>
          <th>{t('outgoing:orderID')}</th>
          <th>{t('outgoing:buyerID')}</th>
          <th>{t('outgoing:orderDate')}</th>
          <th>{t('outgoing:ready')}</th>
          <th>{t('outgoing:status')}</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((el) => {
          return <OneSalesOrderRow {...el} key={el._id} />;
        })}
      </tbody>
    </table>
  );
};
